import api from "../../../components/axiosComp";

export async function getContactEnquirySummary() {
  const { data } = await api.get("/api/superAdmin/contact-enquiries/summary");
  return data;
}

export async function listContactEnquiries(params = {}) {
  const { data } = await api.get("/api/superAdmin/contact-enquiries", { params });
  return data;
}

export async function updateContactEnquiryStatus(id, status) {
  const { data } = await api.patch(
    `/api/superAdmin/contact-enquiries/${id}/status`,
    { status },
  );
  return data;
}

export async function deleteContactEnquiry(id) {
  const { data } = await api.delete(`/api/superAdmin/contact-enquiries/${id}`);
  return data;
}
